import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { TYPOGRAPHY } from "@store/theme/common/design";
import polyfillCss from "@store/theme/common/polyfillCss";
import { css } from "styled-components";

const _cellFontSize = TYPOGRAPHY.size.smaller;
const _baseCellStyles = () => {
    return css`
        height: auto;
        border: 0;
        padding: 1em;
        line-height: ${TYPOGRAPHY.lineHeight.small};
    `;
};

export default {
    defaultProps: {
        cssOverrides: {
            head: css`
                padding: 0 10px;
            `,
            header: polyfillCss`
                ${_baseCellStyles()}
                background-color: ${getColor("secondary.main")} !important;
                color: ${getContrastColor("secondary")};
                text-transform: uppercase;

                a, button {
                    color: inherit;

                    &:hover {
                        text-decoration: underline;
                    }
                }

                &:first-child {
                    padding-left: 2em;
                }

            `,
            cell: polyfillCss`
                ${_baseCellStyles()}
                color: ${getColor("text")};
                font-size: ${_cellFontSize};
                font-weight: ${TYPOGRAPHY.weight.bold};
                text-transform: uppercase;
            `,
            row: polyfillCss`
                padding: 0 10px;
                background-color: ${getColor("common.background")};

                td:first-child {
                    padding-left: 2em;
                }

            `,
            evenRow: polyfillCss` background-color: ${getColor("common.accent")}; `,
        },
        headerTypographyProps: {
            size: _cellFontSize,
            weight: TYPOGRAPHY.weight.bold,
        },
        cellTypographyProps: {
            size: _cellFontSize,
            weight: TYPOGRAPHY.weight.bold,
        },
    },
};
